import(/* webpackMode: "eager" */ "/codebuild/output/src2104561091/src/docloo_nextjs_npm/app/page.tsx")